import React from 'react';
import { FaFileExcel } from "react-icons/fa";
import api, { getToken, isExpired } from '../utils/api'; // ✅ default + named import

export default function ExcelDownloadButton({ deviceId }) {
  const handleDownload = async () => {
    try {
      const response = await api.get(`/devices/${deviceId}/download`, {
        responseType: 'blob', // 바이너리
        timeout: 0,
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')||''}` }
      });

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `device_${deviceId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('엑셀 다운로드 실패:', error);
      alert('다운로드에 실패했습니다.');
    }
  };

  return (
    <button className="download-button" onClick={handleDownload}>
      <FaFileExcel style={{ marginRight: "6px" }} />
      엑셀 다운로드
    </button>
  );
}
